import { AtlasInfo } from "atlas-ds";
import { addDays, isBefore } from "date-fns";

// Le stage est-il considéré comme expirant prochainement ?
export function expiresSoon(date: string) {
    return isBefore(date, addDays(Date.now(), 60))
}

export interface DerniersJoursProps {
    /**
     * La date de fin stage
     */
    dateFin: string
    /**
     * Le message à afficher
     */
    children: React.ReactNode
}

export function DerniersJours(props: DerniersJoursProps) {
    return expiresSoon(props.dateFin) && <AtlasInfo type="warning" title="Derniers jours">
        { props.children }
    </AtlasInfo>
}
